// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Link$Xuder from "../components/Link.bs.js";
import * as Button$Xuder from "../components/Button.bs.js";

require("./NotFoundPage.css");

function NotFoundPage(Props) {
  return React.createElement("div", {
              className: "not-found-page single-page"
            }, React.createElement("div", {
                  className: "content"
                }, React.createElement("h1", undefined, "Not Found"), React.createElement("h3", undefined, "But you can find your future here"), React.createElement(Link$Xuder.make, {
                      route: "/",
                      children: React.createElement(Button$Xuder.make, {
                            children: "Back to home"
                          })
                    })));
}

var make = NotFoundPage;

export {
  make ,
  
}
/*  Not a pure module */
